import { render, staticRenderFns } from "./studyRecordCount.vue?vue&type=template&id=50c7377c&scoped=true&"
import script from "./studyRecordCount.vue?vue&type=script&lang=js&"
export * from "./studyRecordCount.vue?vue&type=script&lang=js&"
import style0 from "./studyRecordCount.vue?vue&type=style&index=0&id=50c7377c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7377c",
  null
  
)

export default component.exports